<script>
import iconSrc from './icons/ai-tutor-icon.svg'

export default {
    props: {
        messages: {
            default() {
                return []
            }
        },
        metadata: {
            default() {
                return null
            }
        },
        info: {
            default() {
                return null
            }
        },
        isSending: Boolean,
        isOverTime: Boolean,
        questionLeft: Number,
        sessionQuestionLeft: Number,
        scrollToBottom: Function,
        partnerConfig: Object,
    },
    data() {
        return {
            iconSrc,
        }
    },
    computed: {
        isSendable() {
            return !this.isSending
                && this.questionLeft !== 0
                && this.sessionQuestionLeft !== 0
                && !this.isOverTime
        }
    },
    mounted() {
        this.scrollToBottom()
    },
    methods: {
        renderMessageContent(content) {
            return window.boChatbot?.renderMessageContent(content)
        },
        handleSuggestedQuestionClick(question) {
            if (!this.isSendable) return;
            window.boChatbot?.sendMessage(question, this.metadata, this.info)
        },
        formatTimestampToArr(timestamp, withSeconds) {
            if (!timestamp) return [];

            var a = new Date(timestamp * 1000);
            var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            var year = a.getFullYear();
            var month = months[a.getMonth()];
            var date = a.getDate();
            var hour = a.getHours();
            var min = a.getMinutes();
            var sec = a.getSeconds();
            const addZero = (num) => {
                return (num < 10) ? '0' + num : num.toString();
            }
            const dateArr = [addZero(date), addZero(month), addZero(year)]
            const timeArr = [addZero(hour), addZero(min)]
            if (withSeconds) {
                timeArr.push(addZero(sec))
            }

            return [dateArr.join('/'), timeArr.join(':')]
        },
        renderMessageMetadata(content) {
            try {
                const metas = []
                const contentJSON = JSON.parse(content)
                const metadata = contentJSON.metadata || contentJSON.context

                if (metadata?.subject) {
                    metas.push(metadata.subject)
                }

                if (metadata?.unit) {
                    metas.push(metadata.unit)
                }

                // if (metadata?.lesson) {
                //     metas.push(metadata.lesson)
                // }

                // if (metadata?.module?.type) {
                //     metas.push(metadata.module.type.toUpperCase())
                // }

                return metas.join(' - ')
            }
            catch {
                return ''
            }
        }
    },
    watch: {
        messages: {
            handler() {
                this.scrollToBottom()
            },
            immediate: true
        }
    }
}
</script>

<template>
    <div v-if="!messages.length" class="message-default">
        <div>Hello, Super iSMART Student!</div>
        <div>What can I assist you today?</div>
    </div>
    <div v-else class="message-list">
        <template v-for="(message, index) in messages">
            <div v-if="message.user.userId !== 'chatbot'">
                <div class="message-datetime message-datetime-user">
                    {{ formatTimestampToArr(message.createdAt).join(' - ') }}
                </div>
                <div class="message message-user" v-html="renderMessageContent(message.content)"></div>
                <div class="message-metadata">
                    {{ renderMessageMetadata(message.content) }}
                </div>
            </div>
            <div v-else class="message-chatbot-wrapper">
                <div class="message-chatbot-avatar">
                    <img :src="partnerConfig?.chatBotAvatarUrl || iconSrc" class="message-chatbot-icon" />
                </div>
                <div>
                    <div class="message-datetime message-datetime-chatbot">
                        {{ formatTimestampToArr(message.createdAt).join(' - ') }}
                    </div>
                    <div class="message message-chatbot" v-html="renderMessageContent(message.content)"></div>
                </div>
            </div>

            <!-- suggested questions -->
            <div v-if="(index + 1) === messages.length && typeof message.content !== 'string' && message.content.suggested_questions?.length && isSendable"
                class="suggested-questions-wrapper">
                <div v-for="question in message.content.suggested_questions" class="suggested-question"
                    v-html="renderMessageContent(question)" @click="handleSuggestedQuestionClick(question)">
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped>
.message-default {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    font-size: 1.2rem;
    color: #0D30A0;
    font-weight: 700;
}

.message-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-bottom: 1rem;
}

.message-datetime {
    font-size: 0.55rem;
    font-style: italic;
    color: #9ca3af;
}

.message-datetime.message-datetime-user {
    text-align: right;
}

.message-metadata {
    font-size: 0.55rem;
    font-style: italic;
    color: #9ca3af;
    text-align: right;
    margin-bottom: 0.2rem;
}

.message {
    border-radius: 0.9rem;
    padding: 0.7rem 0.9rem;
    max-width: 80%;
    width: fit-content;
    font-size: 0.9rem;
    overflow: auto;
}

.message:deep(ul),
.message:deep(ol) {
    padding-left: 1.3rem;
    margin-bottom: 0;
}

.message:deep(li:not(:last-child)) {
    margin-bottom: 0.3rem;
}

.message:deep(img),
.message:deep(audio),
.message:deep(video) {
    max-width: 100%;
}

.message:deep(>*:not(:last-child)) {
    margin-bottom: 1rem;
}

.message:deep(>*:last-child) {
    margin-bottom: 0;
}

.message-user {
    background-color: #D2EEFF;
    color: #0D30A0;
    margin-left: auto;
    border-bottom-right-radius: 0.25rem;
}

.message-chatbot-wrapper {
    display: flex;
    align-items: flex-end;
    gap: 0.3rem;
}

.message-chatbot-avatar {
    border-radius: 100%;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
}

.message-chatbot-icon {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.message-chatbot {
    background-color: #EDEEEE;
    color: #3E3E3E;
    border-bottom-left-radius: 0.25rem;
}

.suggested-questions-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 100%;
    gap: 0.4rem;
    margin-top: 0.4rem;
}

.suggested-question {
    border-radius: 9999px;
    background-color: #fdeecd;
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
    cursor: pointer;
    position: relative;
    font-style: italic;
    margin-left: 1.5rem;
}

.suggested-question:deep(>*) {
    font-style: italic;
    color: #212529;
}

.suggested-question:deep(>*:not(:last-child)) {
    margin-bottom: 1rem;
}

.suggested-question:deep(>*:last-child) {
    margin-bottom: 0;
}

.suggested-question::before {
    content: '✨';
    position: absolute;
    left: -1.5rem;
    font-style: normal;
}

.suggested-question:hover {
    background-color: #facc5d;
}
</style>